import '@/services/events/mockEventsService';
import ReactDOM from 'react-dom/client';
import './styles/main.css';
import {Provider, useSelector} from 'react-redux';
import TipsAndTutorialsPage from '@/containers/TipsAndTutorials/TipsAndTutorialsPage';
import useEvents from '@/hooks/useEvents';
import {configureStore} from '@/state/store';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const App = () => {
    useEvents();

    const isInitialized = useSelector((state) => state.appSlice.isInitialized);

    return (
        <div className='flex h-screen flex-col bg-tips-surface text-tips-text-primary'>
            {isInitialized && <TipsAndTutorialsPage />}
        </div>
    );
};

const start = async () => {
    const store = configureStore();

    render(store, App);
};

const render = (store, Component) => {
    const root = ReactDOM.createRoot(document.getElementById('root'));

    root.render(
        <Provider store={store}>
            <Component />
        </Provider>
    );
};

start();

serviceWorkerRegistration.register();
